import { vappContainer, VApplication } from '@/application';
import { logger as log } from '@common/logger';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { CredentialDetailPageService } from '../../../services';

const MODULE_NAME = 'MyProfilePage.machines.states.getPage';

const getSrv = () => {
  return vappContainer.get<CredentialDetailPageService>(
    CredentialDetailPageService.displayName
  );
};

export const getProfile = async (context: any, event: any) => {
  const currentState = 'GET_PAGE_CONTENT';
  const method = 'getPageContent';
  const storageSrv = StorageModule?.getInstance();
  return new Promise(async (resolve, reject) => {
    try {
      log.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const srv = getSrv();
      const content = await srv.agent.getProfile(event?.payload);
      console.log('getProfile content->', content);
      if (content) {
        return resolve({
          key: 'RENDER_PAGE',
          value: {
            ...(content || {}),
          },
        });
      } else {
        throw {
          message: 'Failed to get profile',
        };
      }
    } catch (err: any) {
      log.error(MODULE_NAME, `error in ${method}, msg: ${err?.message}`);
      let _msg = err?.message?.replace('GraphQL error:', '');
      return reject({
        key: 'RENDER_PAGE_ERROR',
        value: _msg,
      });
    }
  });
};
